import type { TCsvType } from 'App/data-export/components/_utils/createAndDownloadCsvIfApplicable/createCsv'
import { valueTypeRenderers } from 'App/data-export/valueTypeRenderers/valueTypeRenderers'

export const mapCsvTypeToRenderer: Record<TCsvType, (valueType: string) => unknown> = {
  // @ts-ignore
  blocks: (valueType) => valueTypeRenderers[valueType]?.block,
  // @ts-ignore
  irrigationZones: (valueType) => valueTypeRenderers[valueType]?.irrigationZone,
  // @ts-ignore
  points: (valueType) => valueTypeRenderers[valueType]?.point,
}
